export const SourceTypes = {
    APP: 0,
    API: 1,
    AutoRenewed: 2
}

export type SourceTypes = typeof SourceTypes[keyof typeof SourceTypes]